<template>
  <CustomModal ref="modal" title="Forcer le statut">
    <div class="force-status">
      <div class="warning">
        <span class="fas fa-triangle-exclamation warning-icon"></span>
        <div>
          <p><strong>Attention : vous allez passer {{ documentLabel }} à « {{ statusLabel }} » manuellement.</strong></p>
          <p>Habituellement, ce statut change automatiquement dès qu'un encaissement couvrant le montant du document est enregistré. Forcer le statut sans encaissement rendra la synthèse financière du contrat incohérente.</p>
        </div>
      </div>

      <template v-if="proposal">
        <label class="add-collection">
          <input type="checkbox" v-model="addCollection">
          <span>Ajouter l'encaissement associé : <strong>{{ formattedAmount }}</strong></span>
        </label>
        <CustomTextField v-if="addCollection" :content="inputs.date" />
      </template>

      <div class="button-container">
        <CustomButton class="button" @click="confirm" :params="buttons.confirm" />
        <CustomButton class="button" :is-secondary="true" @click="closeModal" :params="buttons.cancel" />
      </div>
    </div>
  </CustomModal>
</template>

<script>
import {NotificationService} from "@vues/v-common";
import CustomButton from "@/components/forms/customs/customButton/CustomButton.vue";
import CustomTextField from "@/components/forms/customs/customTextField/CustomTextField.vue";
import CustomModal from "@/components/modals/CustomModal.vue";
import {convertISOToDate} from "@/utils";

// Confirmation du passage forcé d'un document à payé / remboursé.
// Propose d'ajouter l'encaissement associé (montant et motif déjà calculés, seule la date est demandée).
// callback({addCollection, date}) est appelé à la confirmation.
export default {
  name: 'ForceStatusModal',
  props: ['callback'],
  components: {CustomModal, CustomButton, CustomTextField},
  data() {
    return {
      documentLabel: '',
      statusLabel: '',
      proposal: undefined,
      addCollection: true,
      inputs: {
        date: {label: 'Date de réception du paiement', value: convertISOToDate(new Date()), type: 'date'},
      },
      buttons: {
        confirm: {text: "Forcer le statut"},
        cancel: {text: "Annuler"},
      }
    };
  },
  computed: {
    formattedAmount() {
      return this.proposal
          ? (Number(this.proposal.amount) || 0).toLocaleString('fr-FR', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' €'
          : '';
    }
  },
  methods: {
    // documentLabel : ex. "cette facture", statusLabel : ex. "Payé", proposal : {amount, ...} ou undefined
    openModal({documentLabel, statusLabel, proposal}) {
      this.documentLabel = documentLabel;
      this.statusLabel = statusLabel;
      this.proposal = proposal;
      this.addCollection = true;
      this.inputs.date.value = convertISOToDate(new Date());
      this.inputs.date.error = false;
      this.$refs.modal.openModal();
    },
    closeModal() {
      this.$refs.modal?.closeModal();
    },
    confirm() {
      const withCollection = !!this.proposal && this.addCollection;
      if (withCollection && !this.inputs.date.value) {
        this.inputs.date.error = true;
        (new NotificationService).addNotification("danger", "La date de réception du paiement n'est pas renseignée");
        return;
      }
      this.closeModal();
      this.callback({addCollection: withCollection, date: this.inputs.date.value});
    },
  }
}
</script>

<style lang="stylus" scoped>
.force-status
  display flex
  flex-direction column
  gap 14px
  margin-top 15px

  .warning
    display flex
    gap 10px
    border solid 2px #ffd78e
    background-color #fff6e6
    color #553900
    padding 10px

    p
      margin 0 0 6px
      font-size 13px
      line-height 1.4

    .warning-icon
      flex 0 0 auto
      margin-top 3px

  .add-collection
    display flex
    align-items flex-start
    gap 6px
    font-size 13px
    cursor pointer

  .button-container
    display flex
    flex-direction row-reverse
    justify-content flex-start
    gap 10px

    .button
      min-width 110px
</style>
